import { ThemeProvider } from "./contexts/ThemeContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Logo from "./components/Logo/Logo";
import Navigation from "./components/Navigation/Navigation";
import ScrollToTop from "./components/ScrollToTop";
import Products from "./pages/Products/Products";
import ProductDetail from "./pages/Products/ProductDetail";
import Services from "./pages/Services/Services";
import ServiceDetail from "./pages/Services/ServiceDetail";
import BlogDetail from "./pages/Blogs/BlogDetail";
import News from "./pages/News/News";
import NewsDetail from "./pages/News/NewsDetail";
import Contact from "./pages/Contact/Contact";
import Admin from "./pages/Admin/Admin";
import AdminLogin from "./pages/Admin/AdminLogin";
import BlogForm from "./pages/Blogs/BlogForm";
import NewsForm from "./pages/News/NewsForm";
import ServiceForm from "./pages/Services/ServiceForm";
import ProductForm from "./pages/Products/ProductForm";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";
import "./i18n/i18n";
import Home from "./pages/Home/Home";
import Blog from "./pages/Blogs/Blogs";
import Profile from "./pages/Voting/Profile/Profile";
import Dashboard from "./pages/Voting/Dashboard/Dashboard";
import VotingAdmin from "./pages/Admin-Padma/VotingAdmin";
import DownloadPage from "./pages/Download/DownloadPage";

function App() {
  // console.log("Hello world");
  return (
    <Router>
      <ThemeProvider>
        <ScrollToTop />
        <div className="app">
          <header className="w-full bg-white dark:bg-slate-900 fixed top-0 left-0 z-[110] flex  px-4 py-2 shadow-lg">
            <Logo />
            <Navigation />
          </header>
          <main className=" p-3">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:id" element={<ServiceDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/download" element={<DownloadPage />} />
              {/* <Route path="/voting" element={<Dashboard />} /> */}
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile/:projectId" element={<Profile />} />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin-padma/voting"
                element={
                  <ProtectedRoute>
                    <VotingAdmin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/blog/new"
                element={
                  <ProtectedRoute>
                    <BlogForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/blog/edit/:id"
                element={
                  <ProtectedRoute>
                    <BlogForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/news/new"
                element={
                  <ProtectedRoute>
                    <NewsForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/news/edit/:id"
                element={
                  <ProtectedRoute>
                    <NewsForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/service/new"
                element={
                  <ProtectedRoute>
                    <ServiceForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/service/edit/:id"
                element={
                  <ProtectedRoute>
                    <ServiceForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/product/new"
                element={
                  <ProtectedRoute>
                    <ProductForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/product/edit/:id"
                element={
                  <ProtectedRoute>
                    <ProductForm />
                  </ProtectedRoute>
                }
              />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </Router>
  );
}

export default App;
